import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAllAdsForWebsite } from "../../redux/actions/adsAction";
import { getAllProducts ,allOffersInHomePage,productsFeaturedWithLimit } from "../../redux/actions/productsAction";
import { getSettings } from "../../redux/actions/settingsAcions";

const ViewHomeProductsHooks = () => {
  const dispatch = useDispatch();
  const ref = useRef(null)

  const [loading, setLoading] = useState(true)
  const [items, setitems] = useState([])
  const [Featureditems, setFeatureditems] = useState([])


  useEffect(() => {
    const get = async () => {
      ref.current.continuousStart()
      setLoading(true)
      await dispatch(getAllProducts(8));
      await dispatch(getAllAdsForWebsite())
      await dispatch(allOffersInHomePage())
      await dispatch(productsFeaturedWithLimit(8))
      //offers

      setLoading(false)
      ref.current.complete()
    }
    get()
  }, []);

  const allproduct = useSelector((state) => state.allProduct.allProducts);
  const settingsData = useSelector((state) => state.settingsReducers.settings);
  const adsData = useSelector((state) => state.adsReducers.allAdsWebsite);
  const offers= useSelector((state) => state.allProduct.allOffersInHomePage);
  const productsFeasturedLimit  =  useSelector((state) => state.allProduct.productFeatured);

  let selectedOffers;
  // get only 4 offers
  if(offers)
  {
     selectedOffers= offers.slice(0,8);

    // console.log('selectedOffers');
    // console.log(selectedOffers);
  }
  


  useEffect(() => {
    if (loading === false) {
      // console.log('allproduct')
      // console.log(allproduct)
      setitems(allproduct?.data);
      setFeatureditems(productsFeasturedLimit?.data);
    }

  }, [loading])


  //else Featureditems = [];
  //console.log("jjjjjjjjjjjjjjjjjjjj",Featureditems);
  return [items, settingsData, adsData, Featureditems, ref,selectedOffers];
};

export default ViewHomeProductsHooks;
